import {
  DashboardChartPoint,
  DashboardEvent,
  DashboardStatCard,
  DashboardSummaryCard,
  DashboardUserProfile,
} from './dashboard.interfaces';

export const DEFAULT_DASHBOARD_USER: DashboardUserProfile = {
  username: 'admin',
  fullName: 'System Administrator',
  role: 'ADMIN_USER',
  roleLabel: 'Administrator',
  initials: 'SA',
  department: 'PSOD Portal',
};

export const DASHBOARD_STATS: DashboardStatCard[] = [
  { id: 'outage-all', label: 'No of Outage (ALL)', value: '0', delta: '+0%', tone: 'green' },
  { id: 'outage-rsd', label: 'No of Outage (Rsd)', value: '0', delta: '+0%', tone: 'cyan' },
  { id: 'outage-zero', label: 'No of Outage (Zero Schedule)', value: '4 / 608', delta: '+1%', tone: 'amber' },
  { id: 'outage-forced', label: 'No of Outage (Forced)', value: '2 / 461', delta: '+3%', tone: 'blue' },
  { id: 'outage-planned', label: 'No of Outage (Planned)', value: '2 / 0', delta: '-1%', tone: 'green' },
  { id: 'outage-others', label: 'No of Outage (Others)', value: '2 / 0', delta: '+0%', tone: 'rose' },
  { id: 'water-shortage', label: 'No of Outage (Water Shortage)', value: '0', delta: '+0%', tone: 'cyan' },
  { id: 'coal-shortage', label: 'No of Outage (Coal Shortage)', value: '0', delta: '+0%', tone: 'amber' },
];

export const DASHBOARD_SUMMARY: DashboardSummaryCard[] = [
  { id: 'generation', label: 'Current Generation', value: '1,245 MW', note: 'Balanced across all major stations' },
  { id: 'frequency', label: 'System Frequency', value: '49.98 Hz', note: 'Within normal operating band' },
  { id: 'load', label: 'Peak Demand', value: '1,452 MW', note: 'Forecasted for the next 4 hours' },
  { id: 'availability', label: 'Available Capacity', value: '2,106 MW', note: 'Includes import and reserve margins' },
];

export const DASHBOARD_EVENTS: DashboardEvent[] = [
  {
    id: 'event-1',
    time: '10:45',
    title: 'Frequency normalized after load adjustment',
    detail: 'Dispatch center balanced the grid with a minor import tweak.',
    level: 'success',
  },
  {
    id: 'event-2',
    time: '10:30',
    title: 'Generation mix updated',
    detail: 'Hydro share increased as the day demand curve softened.',
    level: 'info',
  },
  {
    id: 'event-3',
    time: '10:15',
    title: 'One transmission corridor under review',
    detail: 'Maintenance window scheduled for a short duration.',
    level: 'warning',
  },
  {
    id: 'event-4',
    time: '09:50',
    title: 'Scheduled outage status refreshed',
    detail: 'All submitted outage requests are currently in sync.',
    level: 'success',
  },
];

export const LOAD_TIMELINE: DashboardChartPoint[] = [
  { label: '00:00', demand: 980, generation: 940, frequency: 50.04 },
  { label: '03:00', demand: 920, generation: 910, frequency: 49.98 },
  { label: '06:00', demand: 1_020, generation: 980, frequency: 49.92 },
  { label: '09:00', demand: 1_180, generation: 1_120, frequency: 49.88 },
  { label: '12:00', demand: 1_350, generation: 1_245, frequency: 49.95 },
  { label: '15:00', demand: 1_290, generation: 1_220, frequency: 49.97 },
  { label: '18:00', demand: 1_420, generation: 1_300, frequency: 49.91 },
  { label: '21:00', demand: 1_260, generation: 1_180, frequency: 49.96 },
];

export const GENERATION_MIX = [
  { name: 'Hydro', value: 68 },
  { name: 'Solar', value: 8 },
  { name: 'Thermal', value: 4 },
  { name: 'Import', value: 20 },
];
